module.exports = __webpack_public_path__ + "img/canal_denuncias.cc0b2737.jpg";